
import { css } from 'lit';
export default css`
:host {
  display: block;
}

::slotted([slot='icon']) {
  margin-left: 1rem;
  height: 4rem;
  width: 4rem;
  text-align: right;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

@media (min-width: 768px) {

  ::slotted([slot='icon']) {
    display: none;
  }
}

@media (min-width: 1024px) {

  ::slotted([slot='icon']) {
    display: block;
  }
}

::slotted([slot='text']) {
  align-self: center;
  padding-left: 1rem;
  text-align: right;
  font-size: 0.875rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

@media (min-width: 1024px) {

  ::slotted([slot='text']) {
    font-size: 1.125rem;
  }
}

.bg {
  position: relative;
  display: inline-flex;
  height: 3.5rem;
  justify-content: flex-end;
  padding-right: 1.5rem;
}

@media (min-width: 768px) {

  .bg {
    padding-right: 0.5rem;
  }
}

@media (min-width: 1024px) {

  .bg {
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px) {

.bg {
    min-width: 381px
}
  }

.bg::after {
    content: "";
    position: absolute;
    right: -3.5rem;
    width: 0;
    height: 0;
    border-top: 28px solid transparent;
    border-bottom: 28px solid transparent;
    border-right: 28px solid transparent;
  }

@media (min-width: 1024px) {

  .bg::before {
    position: absolute;
  }
}

@media (min-width: 1024px) {

  .bg::before {
    top: 0px;
  }
}

@media (min-width: 1024px) {

  .bg::before {
    z-index: -10;
  }
}

@media (min-width: 1024px) {

  .bg::before {
    height: 100%;
  }
}

@media (min-width: 1024px) {

.bg::before {
      content: "";
      width: 100vw;
      transform: translateX(-100%)
  }
    }

.bg-brand {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.bg-brand::before {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.bg-brand::after {
    border-left: 1.75rem solid #6b1F99;
  }

.bg-emergency {
  --tw-bg-opacity: 1;
  background-color: rgba(211, 18, 41, var(--tw-bg-opacity));
}

.bg-emergency::before {
  --tw-bg-opacity: 1;
  background-color: rgba(211, 18, 41, var(--tw-bg-opacity));
}

.bg-emergency::after {
    border-left: 1.75rem solid #D31229;
  }

.bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgba(231, 157, 12, var(--tw-bg-opacity));
}

.bg-warning::before {
  --tw-bg-opacity: 1;
  background-color: rgba(231, 157, 12, var(--tw-bg-opacity));
}

.bg-warning::after {
    border-left: 1.75rem solid #E79D0C;
  }

.bg-information {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 166, 255, var(--tw-bg-opacity));
}

.bg-information::before {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 166, 255, var(--tw-bg-opacity));
}

.bg-information::after {
    border-left: 1.75rem solid #00A6FF;
  }

.bg-disease {
  --tw-bg-opacity: 1;
  background-color: rgba(6, 168, 110, var(--tw-bg-opacity));
}

.bg-disease::before {
  --tw-bg-opacity: 1;
  background-color: rgba(6, 168, 110, var(--tw-bg-opacity));
}

.bg-disease::after {
    border-left: 1.75rem solid #06A86E;
  }

.bg-alternate {
  --tw-bg-opacity: 1;
  background-color: rgba(35, 35, 35, var(--tw-bg-opacity));
}

.bg-alternate::before {
  --tw-bg-opacity: 1;
  background-color: rgba(35, 35, 35, var(--tw-bg-opacity));
}

.bg-alternate::after {
    border-left: 1.75rem solid #232323;
  }
`;